<style>
	/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
body {
  font-family: "Inter", Lato, sans-serif;
  color: #444444;
}
a {
  color: #004287;
}
a:hover {
  color: #469fdf;
  text-decoration: none;
}
h1, h2, h3, h4, h6 {
  color: #004287;
  font-size: 40px;
}
h1, h2 {
  color: #004287 !important;
}
ul.maintxtbox {
  list-style-type: none;
}
.h5, h5 {
  font-size: 20px;
  color: #676f88;
}
.ap{padding:0px 7px 0px 13px;}
	.rp{padding:0px 13px 0px 0px;}
/*--------------------------------------------------------------
# Header
--------------------------------------------------------------*/
#header {
  transition: all 0.5s;
  background: #004287;
  z-index: 997;
  padding: 10px 0;
  border-bottom: 0px solid #e6f2fb;
}
#header.header-scrolled {
  border-color: #004287;
  box-shadow: 0px 2px 15px rgba(18, 66, 101, 0.08);
}
#header .logo {
  font-size: 28px;
  margin: 0;
  padding: 0;
  line-height: 1;
  font-weight: 300;
  letter-spacing: 0.5px;
  font-family: "Roboto", sans-serif;
}
#header .logo a {
  color: #16507b;
}
#header .logo img {
  max-height: 56px;
  height: 100%;
}
.protxt {
  padding: 0px;
  font-size: 25px;
  color: #fff;
}
.protxth {
  padding: 0px;
  font-size: 28px;
  color: #132145;
  margin: 0px;
}
.pro {
  /*-webkit-box-shadow: 0px 9px 11px 0px rgb(50 50 50 / 60%);
    -moz-box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
    box-shadow: 0px 9px 11px 0px rgb(50 50 50 / 60%);
    border-radius: 50px 22px 50px 50px;
    padding: 30px 40px;
    background: #ffffff;
    border-left: 5px solid #4b94e7;*/
  z-index: -1;
  margin-top: -95px;
}
.logo1 {
  display: block;
}
.logo2 {
  display: none;
}
.fr {
  float: right;
}
.mt {
  margin: 10px 0px !important;
}
.bl {
  width: 10%;
  height: 4px;
  background: none;
  border: none;
  background-position: top left, top center, top right, center right, bottom right, bottom center, bottom left, center left;
  background-size: 0px 0px, calc(100% - (2 * 0px)) 2px, 0px 0px, 2px calc(100% - (2 * 0px));
  background-repeat: no-repeat;
  background-image: radial-gradient(circle at 100% 100%, transparent -2px, #304FFE -2px, #304FFE 0px, transparent 0px), linear-gradient(to right, #304FFE, #D50000), radial-gradient(circle at 0% 100%, transparent -2px, #D50000 -2px, #D50000 0px, transparent 0px), linear-gradient(to bottom, #D50000, #D50000), radial-gradient(circle at 0% 0%, transparent -2px, #D50000 -2px, #D50000 0px, transparent 0px), linear-gradient(to left, #D50000, #304FFE), radial-gradient(circle at 100% 0%, transparent -2px, #304FFE -2px, #304FFE 0px, transparent 0px), linear-gradient(to top, #304FFE, #304FFE);
  margin: 0 auto;
}
.bl1 {
  width: 40%;
  height: 4px;
  background: none;
  border: none;
  background-position: top left, top center, top right, center right, bottom right, bottom center, bottom left, center left;
  background-size: 0px 0px, calc(100% - (2 * 0px)) 2px, 0px 0px, 2px calc(100% - (2 * 0px));
  background-repeat: no-repeat;
  background-image: radial-gradient(circle at 100% 100%, transparent -2px, #304FFE -2px, #304FFE 0px, transparent 0px), linear-gradient(to right, #304FFE, #D50000), radial-gradient(circle at 0% 100%, transparent -2px, #D50000 -2px, #D50000 0px, transparent 0px), linear-gradient(to bottom, #D50000, #D50000), radial-gradient(circle at 0% 0%, transparent -2px, #D50000 -2px, #D50000 0px, transparent 0px), linear-gradient(to left, #D50000, #304FFE), radial-gradient(circle at 100% 0%, transparent -2px, #304FFE -2px, #304FFE 0px, transparent 0px), linear-gradient(to top, #304FFE, #304FFE);
  margin: 0 auto;
}
.form-control {
  /* color: #555b6a; */
  background-color: #fff;
  border-color: #dcdee7;
  height: 45px;
  padding-left: 0px;
  padding-right: 20px;
}
.form-inline .form-control {
  display: inline-block;
  width: 30%;
  vertical-align: middle;
}
.startj {
  display: inline-block;
  padding: 0px;
  margin: 0px;
  height: 45px;
  width: 20%;
  background: #e30011;
  border: none;
  outline: none;
  color: white;
  font-family: inherit;
  font-weight: 400;
  font-size: 20px;
  border-radius: 3px;
  box-shadow: 0 0px 0px #91000b;
  border-bottom: 2px solid #91000b;
  /* float: right; */
}
.startj:hover {
  background: #e30011;
  box-shadow: 0 4px 1px #91000b;
  border-bottom: 2px solid #e30011;
  transition: all 0.1s ease-in;
}
.startj:active {
  transform: translateY(4px);
  border-bottom-width: 2px;
  box-shadow: none;
}
/*--------------------------------------------------------------
# Sections General
--------------------------------------------------------------*/
section {
  padding: 20px 10px;
}
.section-bg {
  background-color: #f8fbfe;
}
.section-title {
  text-align: center;
  padding-bottom: 30px;
}
.section-title h2.h3:after {
  content: "";
  background-color: #e62126;
  height: 4px;
  width: 150px;
  border-radius: 5px;
  position: absolute;
  top: -20px;
  left: calc(50% - 75px);
}
.section-title h2 {
  font-size: 32px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 20px;
  padding-bottom: 0;
  color: #124265;
}
.section-title p {
  margin-bottom: 0;
  font-size: 14px;
  color: #919191;
}
.formcenter{padding: 0px;
    margin: 0px auto;
display: block;}
/*--------------------------------------------------------------
# MAIN
--------------------------------------------------------------*/
.bgmain {
  background-image: url(./assets/images/landing-img20/BG.jpg);
  padding: 0px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0px 0px 0px 0px;
}
.intro {
  display: block;
}
.empower {
  font-size: 32px;
  text-align: center;
}
.IR {
  width: 35%;
  margin: 0 auto;
}
.allp {
  font-size: 19px;
  text-align: center;
  font-weight: 600;
}
.open {
  margin: 60px 0px 4px;
  text-align: left;
  display: block;
  color: #024289;
  font-size: 29px;
  line-height: 1.2;
  padding: 0px 0px 0px;
}
.hello {
  font-family: 'Teko', sans-serif !important;
  font-size: 60px !important;
  line-height: 0.9;
}
.note {
  color: #2d2d2d;
  font-weight: 400;
  font-size: 14px;
  margin: 0px 0px 10px;
  line-height: 1.5;
}
.texttc {
  width: 100%;
  font-size: 12px;
}
.formb {
  border-radius: 10px 10px 0px 0px;
  border: 1px solid;
  padding: 10px;
  border-bottom: 0px;
}
.formcontainer {
  margin: 50px 0px 30px 0px;
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px #ddd;
}
.rg {
  font-size: 25px;
  text-align: center;
  margin: 0 auto;
  padding: 10px;
}
.form-control {
  border: none;
  border-bottom: 2px solid #ddd;
}
.fkficon {
  padding: 100px 0px 0px;
}
.form-group {
  display: block;
  width: 100%;
  text-align: center;
  margin-bottom: 5px;
}
.form-group .errorBlock {
  /* float: left; */
  width: 100%;
  /* margin-bottom: 10px; */
  margin-top: 3px;
  font-size: 14px;
  text-align: center;
  display: block;
}
.form-group .errorBlock a {
  color: #004287;
  text-decoration: underline;
}
.startj {
  display: inline-block;
  padding: 0px;
  margin: 5px;
  height: 38px;
  min-width: 90px;
  width: 100%;
  background: #e30011;
  border: none;
  outline: none;
  color: white;
  font-family: inherit;
  font-weight: 400;
  font-size: 18px;
  border-radius: 3px;
  /* float: right; */
}
.become {
  color: #00b39c;
}
button:focus {
  outline: 0px dotted;
  outline: 0px auto -webkit-focus-ring-color;
}
.startj:hover {
  background: #e30011;
  box-shadow: 0 4px 1px #91000b;
  border-bottom: 2px solid #e30011;
  transition: all 0.1s ease-in;
}
.startj:active {
  transform: translateY(4px);
  border-bottom-width: 2px;
  box-shadow: none;
}
.startjB {
  display: inline-block;
  padding: 0px;
  margin: 5px;
  height: 38px;
  min-width: 90px;
  width: 100%;
  background: #333399;
  border: none;
  outline: none;
  color: white;
  font-family: inherit;
  font-weight: 400;
  font-size: 15px;
  border-radius: 3px;
  /* float: right; */
}
.startjB:hover {
  background: #e30011;
  box-shadow: 0 4px 1px #91000b;
  border-bottom: 2px solid #e30011;
  transition: all 0.1s ease-in;
}
.startjB:active {
  transform: translateY(4px);
  border-bottom-width: 2px;
  box-shadow: none;
}
.form-control:focus, .form-control:active {
  border-color: #004287 !important;
  box-shadow: 0 0 0 0 #fff;
}
.mobile {
  display: none;
}
.vplans {
  display: none;
}
.dtimgQR {
  margin: 0 auto;
  padding: 5px;
}
.planimgtxtA {
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  /* margin-left: 48px; */
  display: block;
  /* float: left; */
}
.planimgtxtAM {
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  /* margin-left: 48px; */
  display: block;
  /* float: left; */
  display: none;
}
.planimgtxtB {
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  display: block;
  float: right;
}
.bproimgA {
  display: flex;
  position: absolute;
}
.bproimgtxtA {
  font-size: 20px;
  font-weight: 500;
  color: #000000;
  padding: 12px 29px 10px 12px;
  vertical-align: middle;
  text-align: left;
  /* position: relative; */
  margin-left: 64px;
  display: block;
}
.bproundA {
  border: 1px solid;
  border-radius: 10px;
  padding: 20px 0px 10px 30px;
}
.bprofdtaA {
  color: #2d2d2d;
  font-weight: 600;
  font-size: 16px;
  margin: 5px 0px 10px;
  line-height: 1.5;
}
.bproimg {
  display: flex;
  position: absolute;
}
.bproimgH {
  padding: 10px;
  margin: 0 auto;
  display: block;
}
.bproimgtxt {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  padding: 6px;
  vertical-align: middle;
  text-align: center;
  /* position: relative; */
  /* margin-left: 64px; */
  display: block;
  font-family: "Lato", sans-serif;
  height: 80px;
}
.list {
  font-size: 19px;
  font-weight: 700;
  padding: 10px;
  vertical-align: middle;
  text-align: center;
  /* position: relative; */
  /* margin-left: 64px; */
  display: block;
  font-family: "Lato", sans-serif;
  background: #00a79d;
  color: #fff;
}
.IRF {
  display: none;
}
.listb {
  background: #2a70ac;
}
.listc {
  background: #27aae2;
}
.listbproundR {
  border: 0px solid #e3232a;
  border-radius: 10px;
  padding: 0px 0px 10px 0px;
  margin-bottom: 20px;
  box-shadow: 0px 9px 11px -11px #000;
  background-color: #f2f1f1;
  height: 260px;
}
.bproundR {
  border: 0px solid #e3232a;
  border-radius: 10px;
  padding: 0px 0px 10px 0px;
  margin-bottom: 20px;
  box-shadow: 0px 9px 11px -11px #000;
  background-color: #f2f1f1;
}
.bproundB {
  border: 1px solid #024289;
  border-radius: 10px;
  padding: 20px 0px 10px 0px;
  margin-bottom: 20px;
}
.bprofdta {
  color: #2d2d2d;
  font-weight: 600;
  font-size: 20px;
  margin: 14px 0px 40px;
  line-height: 1.5;
}
.bl1proB {
  width: 40%;
  /* height: 4px; */
  background: none;
  border: 4px solid #024289;
  margin: 0px 0px 0px 0px;
  transform: rotate(180deg);
  position: absolute;
  border-radius: 8px;
}
.bl1pro1B {
  width: 40%;
  background: none;
  border: 4px solid #024289;
  margin: 55px 0px 0px -55px;
  transform: rotate(90deg);
  position: absolute;
  border-radius: 8px;
}
.bl1proR {
  width: 40%;
  /* height: 4px; */
  background: none;
  border: 4px solid #e3232a;
  margin: 0px 0px 0px 0px;
  transform: rotate(180deg);
  position: absolute;
  border-radius: 8px;
}
.bl1pro1R {
  width: 40%;
  background: none;
  border: 4px solid #e3232a;
  margin: 55px 0px 0px -55px;
  transform: rotate(90deg);
  position: absolute;
  border-radius: 8px;
}
.dtimg {
  display: block !important;
  margin: 0 auto;
  padding: 25px 0px 0px;
  /*width: 76px;*/
}
.mobiledownload {
  font-size: 36px;
  font-family: Montserrat;
  color: #004287;
  line-height: 1.2;
}
.mbline {
  border: 1px solid #f00;
  border-radius: 10px 9px 0px 0px;
  border-bottom: 0px;
  padding: 10px 0px 0px;
}
.sj {
  padding: 10px 18px;
  font-size: 21px;
  display: inline-block;
  /* padding: 15px; */
  height: 50px;
  background: #ffffff;
  border: none;
  outline: none;
  color: #004287;
  font-family: inherit;
  font-weight: 400;
  border-radius: 20px;
  margin: 25px;
  width: 100%;
  max-width: 275px;
}
.dta {
  color: #2d2d2d;
  font-weight: 600;
  font-size: 42px;
  margin: 0px 0px 5px;
}
.dta1 {
  font-family: "Teko", Inter, Lato, sans-serif;
  color: #333333;
  font-weight: 100;
  font-size: 70px;
  margin: 0px 0px 0px;
}
.fdta {
  font-family: "Teko", Inter, Lato, sans-serif;
  color: #662D91;
  font-weight: 100;
  font-size: 47px;
  margin: 0px 0px 0px;
}
.pb {
  padding-bottom: 40px;
}
.bgFeatures {
  background: #fff;
  padding: 30px 100px 80px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.bgadvantage {
  background: #fff;
  padding: 50px 100px 20px 100px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.MTbgadvantage {
  background: #ffffff;
  padding: 30px 100px 20px 100px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.advantagth {
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  padding: 10px 0px 15px;
  vertical-align: middle;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  height: 75px;
}
.headth {
  text-align: left;
  font-size: 20px;
  width: 100%;
  padding: 0px;
  margin: 0;
}
.Features {
  font-size: 18px;
  font-weight: 300;
  color: #ffffff;
  padding: 20px 0px 20px;
  vertical-align: middle;
  margin: 0 auto;
  text-align: center;
  width: 100%;
}
.mtt {
  -webkit-box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  -moz-box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  border-radius: 80px 22px 80px 80px;
  padding: 30px 40px;
  background: #f3f3f5;
  border: 2px solid #f03042;
}
.Gmtt {
  -webkit-box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  -moz-box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  border-radius: 80px 22px 80px 80px;
  padding: 30px 40px;
  background: #ffff;
  border: 2px solid #f03042;
}
.mttB {
  -webkit-box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  -moz-box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  border-radius: 80px 22px 80px 80px;
  padding: 30px 40px;
  background: #f3f3f5;
  border: 2px solid #004287;
}
.Dpro {
  -webkit-box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  -moz-box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  box-shadow: 0px 9px 11px 0px rgba(50, 50, 50, 0.6);
  border-radius: 50px 22px 50px 50px;
  padding: 30px 40px;
  background: #ffffff;
  border-left: 5px solid #004287;
}
.drimg {
  position: absolute;
  display: flex;
  padding-top: 120px;
}
.vl {
  border-left: 4px solid #f03042;
  height: 73px;
  position: absolute;
  left: 0%;
  margin-left: -3px;
  top: 0;
  border-radius: 10px;
}
.Gadvantagth {
  font-size: 19px;
  font-weight: 500;
  color: #000000;
  padding: 0px 0px 0px;
  vertical-align: middle;
  margin: 0 auto;
  text-align: left;
  width: 100%;
}
.img-responsive {
  display: block;
  max-width: 100%;
  height: auto;
}
.pro1 {
  background-color: #004287;
  border-radius: 10px 0px 0px 10px;
}
.pro1_1 {
  background-color: #004287;
  border-radius: 0px 10px 10px 0px;
}
.pro2 {
  background-color: #e30011;
  border-radius: 0px;
}
.pro3 {
  background-color: #004287;
  border-radius: 0px 0px 0px 0px;
}
.disclamer {
  background: #004287;
  color: #fff;
  font-size: 16px;
  padding: 0px;
  margin: 0px auto;
}
.disclamer p {
  color: #333;
  text-align: justify;
}
.plan {
  font-size: 20px;
  color: #004287;
  font-weight: 500;
}
.plantxt {
  font-size: 16px;
  color: #2d2d2d;
  font-weight: 500;
}
.planH {
  font-size: 19px;
  color: #f03042;
}
/*---------------------sticky cta--------------------
	-----------------------------------------------*/
.sticky-cta button.sem-oda-form-submit {
  background-color: #2a70ac;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: #fff;
  border: 0px;
  border-radius: 0;
  margin-bottom: 0;
  z-index: 100;
  width: 100%;
  position: fixed;
  bottom: 0;
  padding: 12px 30px;
  cursor: pointer;
  display: none;
}
/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/
#secondary_nav {
  position: relative;
  width: 100%;
  height: 46px;
  background: red;
}
#secondary_nav.sticky {
  position: fixed;
  bottom: 0px;
}
#footer {
  color: #ffffff;
  font-size: 18px;
  background: #025296;
  box-shadow: 0px 2px 15px rgba(18, 66, 101, 0.08);
}
#footer .credits {
  padding-top: 5px;
  font-size: 13px;
  color: #ffffff;
}
.back-to-top {
  position: fixed;
  bottom: 120px;
  right: 25px;
  display: none;
  z-index: 9999;
}
.top {
  background: #004287;
  color: #fff;
}
.top:hover {
  background: #e30011;
  color: #fff;
}
.productlist{ 
	padding: 5px 0px !important;
    list-style: disc !important;
    margin: 0px 40px 0px !important;
}
/*--------------------------------------------------------------
# media
--------------------------------------------------------------*/
@media (max-width: 1024px) {
  .fdta {
    font-size: 34px;
  }
  .dta1 {
    font-size: 50px;
    margin: 0px 0px 10px;
  }
  .protxt {
    padding: 0px 83px;
  }
  .dtasub {
    display: block;
    font-size: 15px;
  }
  .bgmain {
    padding: 80px 0px 0px;
  }
  .open {
    margin: 30px 8px 10px;
    line-height: 1.2;
    font-size: 24px;
  }
	
  .bproimg {
    width: 43%;
  }
  .bgadvantage {
    padding: 50px 0px 0px;
  }
  .protxth {
    padding: 39px 0px 0px;
    font-size: 24px;
    color: #132145;
    margin: 0px;
  }
  .sj {
    margin: 25px 0px;
    width: 100%;
  }
  .MTbgadvantage {
    background: #ffffff;
    padding: 30px 10px 0px 10px;
  }
  .drimg {
    position: absolute;
    display: flex;
    padding-top: 180px;
  }
  .vl {
    border-left: 4px solid #f03042;
    height: 95px;
  }
  .bgFeatures {
    background: #fff;
    padding: 30px 10px 80px;
  }
  .formcontainer {
    margin: 15px 0px;
  }
	.startjB { font-size: 13px;}
  .startj {
    display: inline-block;
    padding: 0px;
    margin: 5px;
    height: 39px;
    width: 100%;
    background: #e30011;
    border: none;
    outline: none;
    color: white;
    font-family: inherit;
    font-weight: 400;
    font-size: 21px;
    border-radius: 3px;
    box-shadow: 0 0px 0px #91000b;
    border-bottom: 0px solid #91000b;
    /* float: right; */
  }
  .note {
    font-size: 12px;
  }
  .fkficon {
    padding: 30px 0px 0px;
  }
  .advantagth {
    font-size: 17px;
  }
  .bproundA {
    padding: 20px 0px 10px 0px;
  }
  .bproimgtxtA {
    padding: 12px 0px 10px 12px;
    margin-left: 60px;
  }
  .bl1pro1R {
    margin: 47px 0px 0px -46px;
  }
  .bl1pro1B {
    margin: 47px 0px 0px -46px;
  }
  .bproimgtxt {
    font-size: 16px;
  }
}
@media (max-width: 992px) {
  #header .logo {
    font-size: 28px;
  }
  .protxt {
    padding: 0px;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: "Roboto", sans-serif;
    color: #004287;
    font-size: 36px;
  }
  .intro {
    font-family: 'Pacifico', cursive;
    font-size: 25px !important;
    color: #ff0000;
  }
  .open {
    
    line-height: 1.2;
    font-size: 29px;
    text-align: center;
  }
  .ref {
    color: #333333;
    font-weight: 600;
    font-size: 22px;
  }
  .pro2 {
    background-color: #e30011;
    border-radius: 0px 10px 0px 0px;
  }
  .pro1 {
    background-color: #004287;
    border-radius: 10px 0px 0px 0px;
  }
  .pro3 {
    background-color: #004287;
    border-radius: 0px 0px 10px 10px;
  }
  .dta1 {
    /*font-size: 28px;*/
    margin: 0px 0px 10px;
  }
  .listbproundR {
    height: 300px;
  }
  /*.dta {
    font-size: 37px;
}
.fdta {
    font-size: 17px;
}*/
  .bgFeatures {
    background: #fff;
    padding: 30px 10px 80px;
  }
  .pro2 {
    background-color: #e30011;
    border-radius: 0px 0px 0px 0px;
  }
  .pro1 {
    background-color: #004287;
    border-radius: 10px 0px 0px 0px;
  }
  .pro3 {
    background-color: #004287;
    border-radius: 0px 10px 0px 0px;
  }
  .pro1_1 {
    background-color: #004287;
    border-radius: 0px 0px 10px 0px;
  }
  .hover-div {
    margin: 11px 30px;
  }
  .drimg {
    position: relative;
    display: flex;
    padding-top: 0px;
    float: right;
  }
  .Gadvantagth {
    padding: 0px 0px 20px;
    width: 100%;
    font-size: 18px;
  }
  .dtimg {
    display: block !important;
    margin: 0 auto;
    padding: 25px 0px 0px;
    width: 90%;
    max-width: 200px;
  }
  .bproimgtxt {
    font-size: 18px;
  }
	.startjB{font-size: 18px;}
}
@media (max-width: 900px) {
  .bp {
    display: none;
  }
  .fkficon {
    padding: 0px 0px 0px;
    width: 40%;
  }
  .planimgtxtA {
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    margin-left: 48px;
    display: block;
    /* float: left; */
  }
  .planimgtxtB {
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    display: block;
    float: right;
  }
  .bproimgA {
    display: flex;
    position: absolute;
    width: 25%;
  }
  .bproimgtxtA {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    padding: 0px;
    vertical-align: middle;
    text-align: left;
    /* position: relative; */
    margin-left: 54px;
    display: block;
  }
  .bproundA {
    border: 1px solid;
    border-radius: 10px;
    padding: 20px 0px 10px 0px;
  }
  .bl1pro1R {
    margin: 69px 0px 0px -69px;
  }
  .bl1pro1B {
    margin: 69px 0px 0px -69px;
  }
  
}
@media (max-width: 767px) {
  /*.intro {
    display: none;
}*/
  .protxt {
    padding: 0px;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: "Roboto", sans-serif;
    color: #004287;
    font-size: 30px;
    line-height: 1.3;
    margin-top: 10px;
  }
  ul.maintxtbox {
    list-style-type: none;
    padding-inline-start: 0px;
  }
  .back-to-top {
    position: fixed;
    bottom: 110px;
    right: 15px;
    display: none;
  }
  .bl1pro1R {
    display: none;
  }
  .bl1pro1B {
    display: none;
  }
  .bl1proR {
    display: none;
  }
  .bl1proB {
    display: none;
  }
  .IRF {
    display: block;
  }
  .IRFimg {
    width: 40%;
    margin: 0 auto;
  }
  .DIRF {
    display: none;
  }
	.ap {
    padding: 0px 15px 0px 15px;
}
	.rp {
    padding: 0px 15px 0px 15px;
}
}
@media (max-width:760px) {
  .bgmain {
    padding: 40px 0px 0px;
    background: #fff;
  }
  .pro {
    z-index: -1;
    margin-top: 0px;
  }
  .pro1 {
    background-color: #004287;
    border-radius: 10px;
    margin-bottom: 30px;
  }
  .pro1_1 {
    border-radius: 10px;
    margin-bottom: 30px;
  }
  .pro2 {
    background-color: #e30011;
    border-radius: 10px;
    margin-bottom: 30px;
  }
  .pro3 {
    background-color: #004287;
    border-radius: 10px;
    margin-bottom: 30px;
  }
  .hover-div {
    margin: 11px 0px;
  }
  .vl {
    border-left: 4px solid #f03042;
    height: 80px;
  }
  .faqh {
    font-size: 17px;
    color: #333;
  }
  .planimgtxtA {
    font-size: 18px;
    font-weight: 500;
    color: #000000;
    /* margin-left: 48px; */
    display: block;
    /* float: left; */
    display: none;
  }
  .planimgtxtAM {
    font-size: 18px;
    font-weight: 500;
    color: #000000;
    /* margin-left: 48px; */
    display: block;
    /* float: left; */
  }
}
@media (max-width: 640px) {
  .bgmain {
    background: #ffffff;
    padding: 0px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 50px;
  }
  .open {
    margin: 26px 3px 20px;
    text-align: center;
    color: #004287;
    line-height: 1.2;
    font-size: 28px;
  }
  .intro {
    margin: 0 auto;
  }
  .form-group p {
    font-size: 15px;
    text-align: center;
    margin: 0px;
  }
  .fkficon {
    padding: 25px 0px 0px;
  }
  .mobile {
    display: block;
  }
  .form-inline .form-control {
    display: inline-block;
    width: 100%;
    vertical-align: middle;
  }
  .startj {
    display: inline-block;
    padding: 0px;
    margin: 5px;
    width: 100%;
  }
  .headth {
    text-align: center;
    font-size: 20px;
    width: 100%;
    padding: 0px;
    margin: 0;
  }
  .btn-6 {
    margin: 17px auto 0px auto;
    text-align: center;
    display: block;
  }
  .bgFeatures {
    background: #fff;
    padding: 30px 10px 80px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .MTbgadvantage {
    padding: 30px 10px 0px 10px;
  }
  
  .Gadvantagth {
    padding: 0px 0px 20px;
    width: 100%;
  }
  .Gmtt {
    padding: 10px 40px;
  }
  .sj {
    margin: 20px auto;
    width: 100%;
    max-width: 275px;
    padding: 0px;
    font-size: 20px;
  }
  .dta {
    margin-bottom: 10px;
    font-size: 25px;
    line-height: 1.2;
  }
  .fdta {
    margin-bottom: 10px;
    font-size: 23px;
    line-height: 1.2;
  }
  .bgadvantage {
    padding: 10px 10px 0px;
  }
  .Dpro {
    padding: 30px 5px;
    background: #ffffff;
  }
  .drimg {
    position: relative;
    display: flex;
    padding-top: 0px;
  }
  .formcontainer {
    margin: 0px 0px;
  }
  .dtimg {
    display: block !important;
    width: 250px;
    margin: 0 auto;
  }
  .protxt {
    padding: 0px;
    font-size: 20px;
  }
  .formcontainer {
    margin: 0px 0px;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: "Roboto", sans-serif;
    color: #004287;
    font-size: 26px;
    line-height: 1.3;
    margin-top: 10px;
  }
  .mt {
    margin: 0px 0px !important;
  }
  .vplans1 {
    display: none;
  }
  section {
    padding: 10px 10px;
  }
  .bs-example {
    margin: 20px 0px;
  }
  .dta1 {
    font-size: 35px;
    margin: 0px 0px 0px;
    line-height: 1.2;
  }
  .vplans {
    display: none;
  }
  .bproimg {
    display: flex;
    position: relative;
    margin: 0 auto;
  }
  .bproundR {
    padding: 0px 0px 10px 0px;
    width: 71%;
    margin: 0 auto 20px;
  }
  .IR {
    width: 100%;
    margin: 0 auto;
  }
  .empower {
    font-size: 24px;
  }
  .allp {
    font-size: 17px;
  }
  .bproimgtxt {
    font-size: 14px;
    font-weight: 500;
    padding: 0px 10px 0px;
    vertical-align: middle;
    margin: 0px auto;
    text-align: center;
    width: 100%;
    position: relative;
    margin-left: 0px;
    
  }
  .bproundA {
    border: none;
    padding: 20px 0px 10px 0px;
  }
  .bproimgA {
    display: flex;
    position: relative;
  }
  .bproimgtxtA {
    padding: 0px 0px 10px 0px;
    vertical-align: middle;
    text-align: center;
    margin-left: 0px;
  }
  .advantagth {
    padding: 10px 0px 5px;
  }
  .planimgtxtB {
    font-size: 20px;
    display: block;
    float: none;
    text-align: center;
  }
}
@media (max-width: 575px) {
  .logo2 {
    display: block;
  }
  .logo1 {
    display: none;
  }
  .advantagth {
    font-size: 18px;
  }
  .planimgtxtB {
    font-size: 17px;
    display: block;
    float: none;
    text-align: center;
  }
}
@media (max-width: 480px) {
  h1, h2, h3, h4, h5, h6 {
    font-family: "Roboto", sans-serif;
    color: #004287;
    font-size: 30px;
    line-height: 1.3;
    margin-top: 10px;
  }
  .HE {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    display: block;
  }
  .Gadvantagth {
    padding: 0px 0px 20px;
    width: 100%;
    font-size: 20px;
  }
}
@media (max-width: 360px) {
  h1, h2, h3, h4, h5, h6 {
    font-family: "Roboto", sans-serif;
    color: #004287;
    font-size: 26px;
    line-height: 1.3;
    margin-top: 10px;
  }
  .m360 {
    margin: -37px -120px;
    position: absolute;
    font-size: 15px;
  }
}
</style>
<head>
	
	<meta charset="utf-8">
	<meta content="width=device-width, initial-scale=1.0" name="viewport">
	<title>Hello Partner Become a Financial Superstore!</title>
	<meta name="descriptison" content="">
	<meta  name="keywords" content="">
	<meta property="og:title" content="HDFC securities">
	<meta property="og:description" content="Hello Partner Become a Financial Superstore!">
	<meta property="og:image" content="./assets/images/landing-img20/B2B.jpg"/>
	<meta property="og:url" content="#">
	
	<!-- CSS Files -->
</head>
<!-- ======= Header ======= -->
<!-- <header id="header" class="fixed-top">
	<div class="container  align-items-center">
	  <div class="row">
		<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
		  <h1 class="logo mr-auto img-responsive fl mt"><a href="https://www.hdfcsec.com/" target="_blank"><img src="./assets/images/landing-img20/hsl_logo.png" alt="HDFC securities." ></a></h1>
		</div>
		<div class="clearfix"></div>
	  </div>
	</div>
  </header> -->
  <!-- End Header -->
  
  <main id="main">
	<section class="bgmain">
	  <div class="container">
		<div class="row">
		  <div class="col-sm-12 col-md-0 col-lg-5 wow fadeInDown" data-wow-delay="300ms"> </div>
		  <div class="col-sm-12 col-md-4 col-lg-2 wow fadeInDown" data-wow-delay="300ms">
			<h1 class="open"> <span class="hello">HELLO PARTNER!</span><br>
			  <span class="become">Become a Financial Superstore!</span></h1>
		  </div>
		  <div class="col-lg-5 col-md-8 col-sm-12 wow fadeInDown" data-wow-delay="300ms"  >
			<div class="col-lg-10 col-md-12 col-sm-12 text-center formcenter"  >
			  <div>
				<fieldset id="eotp">
				  <form action="/action_page.php">
					<div class="formcontainer">
					  <div class="container">
						<h1 class="rg">Partner with us</h1>
						<div class="form-group">
						  <!-- <select name="Category" id="Category" class="form-control"  style="height:45px" required>
							<option value="Partner Category">Select Partner Category</option>
							<option value="Authorised Person">Authorised Person</option>
							<option value="Authorised Person">Master Franchisee</option>
							<option value="Referral Partner">Referral Partner</option>
							<option value="NRI Partner">NRI Partner</option>
						  </select> -->
						  <select  name="cboCategory" id="cboCategory" class="form-control" (change)="onCategorySelected(data.CategoryCode)" [disabled]="showOtp"
						  [(ngModel)]="data.CategoryCode">
										   <option [ngValue]="0" selected disabled></option>
										   <option *ngFor="let p of PartenerCategory" [ngValue]="p.CategoryCode">
											   {{p.CategoryName}}
										   </option>
									   </select>
						</div>
						<div class="form-group">
							<input *ngIf="data.CategoryCode=='AP' || data.CategoryCode=='RP'|| data.CategoryCode=='NP'|| data.CategoryCode=='0'||data.CategoryCode=='MF'" id="txtName" name="txtName" type="text" class="form-control" placeholder="Name" [(ngModel)]="lead.Name" maxlength="100" autocomplete="off" [disabled]="showOtp" (keypress)="keyPressAcceptOnlyChar($event)" style="height:45px"  />
						</div>
						<div class="form-group">
							<input  *ngIf="data.CategoryCode=='AP' || data.CategoryCode=='RP'|| data.CategoryCode=='NP'|| data.CategoryCode=='0'||data.CategoryCode=='MF'" id="txtEmail" name="txtEmail" type="text" class="form-control" placeholder="Email" [(ngModel)]="lead.Email" maxlength="100" autocomplete="off" [disabled]="showOtp" style="height: 45px;" />
						</div>
						<div class="form-group">
							<input *ngIf="data.CategoryCode=='AP' || data.CategoryCode=='RP'|| data.CategoryCode=='0'||data.CategoryCode=='MF'" type="tel" class="form-control" aria-describedby="numbHelp" placeholder="Your 10 digit mobile number" id="txtMobile" name="txtMobile" [(ngModel)]="lead.Mobile" maxlength="10" onkeypress="return !isNaN(event.key) || event.charCode == 13" autocomplete="off" [disabled]="showOtp" style="height:45px" />
						</div>
						<div class="form-group" style="display:none;">
							<input type="tel" name="txtOtp" id="txtOtp" class="form-control" placeholder="Enter OTP" [(ngModel)]="lead.Otp" onkeypress="return !isNaN(event.key) && event.key != ' '" maxlength="6" [disabled]="disableOtp" *ngIf="showOtp" autocomplete="off" style="height:45px" />

							<span class="psw"><a style="text-decoration:underline;float:right;padding:3px 0px" (click)="generateOtp(true)" *ngIf="showOtp"> Get New OTP</a></span>
						</div>
            
						  <div class="form-group">
						  <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-6">
								<input *ngIf="data.CategoryCode=='AP' || data.CategoryCode=='RP'|| data.CategoryCode=='0'||data.CategoryCode=='MF'" type="text" placeholder="Enter Pincode"
                [(ngModel)]="lead.PinCode"  (keyup) = "enterpincode($event)"
                pattern = "^\d{10}$" 
                maxlength="6" name="pincode" autocomplete="off" [disabled]="showOtp" class="form-control" 
                required />
							</div>

              <div class="col-xs-12 col-sm-12 col-md-6">
								<input  *ngIf="data.CategoryCode=='AP' || data.CategoryCode=='RP'|| data.CategoryCode=='0'||data.CategoryCode=='MF'" 
                id="txtCity" name="txtCity" type="text" class="form-control" placeholder="City" [(ngModel)]="lead.City" maxlength="100" (keypress)="keyPressAcceptOnlyChar($event)"
                autocomplete="off"  style="height:45px" required/>
							</div>
						</div>
					  </div>
      
						<div class="form-group">
						  <h5 style="text-align:center;margin:0 auto;font-size:15px;padding:5px;">
							<input type="checkbox" id="TNCCondition"   [(ngModel)]="lead.agreeTerms" checked disabled/>
							I agree <a href="https://www.hdfcsec.com/referral-partner-terms-and-conditions" target="_blank">Terms &amp; Conditions</a></h5>
						</div>
						<div class="form-group">
							<button type="submit" class="btn btn-danger btn-lg startj" (click)="generateOtp(false)" *ngIf="!showOtp">Submit</button>
							<button type="submit" class="btn btn-danger btn-lg startj" (click)="validateOtp()" *ngIf="showOtp">Validate</button>

						</div>
						<div class="form-group">
						  <div class="row">
							<div class="col-xs-12 col-sm-12 col-md-6 ap"> 
                <a href= "{{urldata.ApCode}}" target="_blank">
							  <button type="button" id = "AP" class="btn btn-danger btn-lg startjB"  >Generate AP Code</button>
							  </a>
               </div>
							<div class="col-xs-12 col-sm-12 col-md-6 rp"> 
                <a href="{{urldata.RpCode}}" target="_blank">
							  <button type="button" id = "RP" class="btn btn-danger btn-lg startjB"  >Generate RP Code</button>
							  </a> 
              </div>
							<!-- <div class="col-xs-12 col-sm-12 col-md-12">
                 <a href="{{urldata.PpLogin}}" target="_blank">
							  <button type="button"id = "PP" class="btn btn-danger btn-lg startjB"  >Partner Portal Login</button>
							  </a> 
              </div> -->
						  </div>
						</div>
					  </div>
					</div>
				  </form>
				</fieldset>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	</section>
	<!-- End Breadcrumbs -->
	
	<div class="sticky-cta">
	  <button class="cta primary common sem-oda-form-submit" id="button1">Become a Partner with Us </button>
	</div>
	<section>
	  <div class="container">
		<div class="row wow fadeInUp" data-wow-delay="500ms">
		  <div class="col-lg-12  mt-2 text-center">
			<h2 class="dta1"><span style="color:#262262;">UPTO 80%* OF REVENUE SHARING</span></h2>
			<h4 class="fdta text-center"> BENEFITS OF PARTNERING WITH HDFC SECURITIES </h4>
			<hr/>
		  </div>
		</div>
		<div class="row">
		  <div class="col-lg-2 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="800ms">
			<div class="bproundR"> <img class="img-responsive" alt="Timely and Competitive payout" src="./assets/images/landing-img20/Asset 1.png" data-holder-rendered="true" style="margin:0 auto;">
			  <h3 class="bproimgtxt">Timely and Competitive Payout </h3>
			</div>
		  </div>
		  <div class="col-lg-2 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="850ms">
			<div class="bproundR"> <img class="img-responsive" alt="Attractive earning" src="./assets/images/landing-img20/Asset 2.png" data-holder-rendered="true" style="margin:0 auto;">
			  <h3 class="bproimgtxt">Attractive Earning on Wide Array of Products </h3>
			</div>
		  </div>
		  <div class="col-lg-2 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="900ms">
			<div class="bproundR"> <img class="img-responsive" alt="No retirement age" src="./assets/images/landing-img20/Asset 3.png" data-holder-rendered="true" style="margin:0 auto;">
			  <h3 class="bproimgtxt">No Retirement Age </h3>
			</div>
		  </div>
		  <div class="col-lg-2 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="950ms">
			<div class="bproundR"> <img class="img-responsive  " alt="Quality training" src="./assets/images/landing-img20/Asset 4.png" data-holder-rendered="true" style="margin:0 auto;">
			  <h3 class="bproimgtxt">Quality Training and Support </h3>
			</div>
		  </div>
		  <div class="col-lg-2 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="1000ms">
			<div class="bproundR"> <img class="img-responsive  " alt="No Hidden Charges" src="./assets/images/landing-img20/Asset 5.png" data-holder-rendered="true" style="margin:0 auto;">
			  <h3 class="bproimgtxt">No Hidden Charges </h3>
			</div>
		  </div>
		  <div class="col-lg-2 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="1200ms" >
			<div class="bproundR"> <img class="img-responsive  " alt="RMSupport" src="./assets/images/landing-img20/Asset 6.png" data-holder-rendered="true" style="margin:0 auto;">
			  <h3 class="bproimgtxt">RM Support </h3>
			</div>
		  </div>
		  <div class="col-lg-12  mt-2 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive  " alt="Option Strategy" src="./assets/images/landing-img20/Asset 7.png" data-holder-rendered="true" style="margin:0 auto;"> </div>
		</div>
	  </div>
	</section>
	<section>
	  <div class="container">
		<div class="row">
		  <div class="col-lg-4 col-md-4 col-sm-4 text-center wow fadeInUp" data-wow-delay="800ms">
			<div class="listbproundR">
			  <h3 class="list">Equity Products</h3>
			  <ul class="text-left">
				<li class="productlist">Equity</li>
				<li class="productlist">Derivatives</li>
				<li class="productlist">Currency</li>
				<li class="productlist">Commodities</li>
			  </ul>
			</div>
		  </div>
		  <div class="col-lg-4 col-md-4 col-sm-4 text-center wow fadeInUp" data-wow-delay="900ms">
			<div class="listbproundR">
			  <h3 class="list listb">Fixed Income / Wealth Products</h3>
			  <ul class="text-left">
				<li class="productlist">Corporate Fixed Deposit</li>
				<li class="productlist">Bonds</li>
				<li class="productlist">NPS</li>
				<li class="productlist">NCDs</li>
				<li class="productlist">IPO/FPO</li>
				<li class="productlist">AIF and PMS</li>
			  </ul>
			</div>
		  </div>
		  <div class="col-lg-4 col-md-4 col-sm-4 text-center wow fadeInUp" data-wow-delay="1000ms">
			<div class="listbproundR">
			  <h3 class="list listc">Mutual Funds</h3>
			  <ul class="text-left">
				<li class="productlist">SIP</li>
				<li class="productlist">Lumsumps</li>
				<li class="productlist">MF Reckoner</li>
			  </ul>
			</div>
		  </div>
		</div>
	  </div>
	</section>
	<!-- New Invest Right app -->
	<section>
	  <div class="container">
		<div class="row wow fadeInUp" data-wow-delay="1000ms">
		  <div class="col-lg-12  mt-2 text-center">
			<p class="empower">Empower your clients with</p>
			<img src="./assets/images/landing-img20/Asset 8.png" class="img-responsive IR" alt="Investright">
			<p class="allp">Speed, Versatility, Value and Ease of use - all clubbed into one platform.</p>
		  </div>
		</div>
		<div class="row wow fadeInUp DIRF" data-wow-delay="1000ms">
		  <div class="col-lg-12 col-md-12 col-sm-12 text-center"> <img class="img-responsive" alt="Introducing our all new power packed investment app! Invest Right" src="./assets/images/landing-img20/Asset 9.png" data-holder-rendered="true" style="margin:0 auto;width:85%;"> </div>
		  <p class="texttc">*Terms and conditions apply. Investment in securities market are subject to market risks. Read all the related documents carefully before investing.
			Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors. Mutual Funds Investments are subject to market risk. Please read the offer and scheme related documents carefully before investing. The securities quoted are exemplary and not recommendatory or actual. Quantities, amounts, figures, graphs, and rates shown/displayed are exemplary and not recommendatory ar actual. </p>
		</div>
		 <div class="row d-lg-none d-md-none ">
		  <div class="col-md-6 col-sm-6 col-lg-2 text-center wow fadeInUp" data-wow-delay="800ms"> <img class="img-responsive IRFimg" alt="Hyper-personalize App" src="./assets/images/landing-img20/A1.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Hyper-personalize App as per usage </h3>
		  </div>
		  <div class="clearfix"></div>
		  <div class="col-md-6 col-sm-6 col-lg-2 text-center wow fadeInUp" data-wow-delay="800ms"> <img class="img-responsive IRFimg" alt="Live Screeners" src="./assets/images/landing-img20/A2.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Live Screeners for trading ideas </h3>
		  </div>
		  <div class="clearfix"></div>
		  <div class="col-md-6 col-sm-6 col-lg-2 text-center wow fadeInUp" data-wow-delay="800ms"> <img class="img-responsive IRFimg" alt="Peer comparison analysis" src="./assets/images/landing-img20/A3.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Peer comparison analysis </h3>
		  </div>
		  <div class="col-md-6 col-sm-6 col-lg-2 text-center wow fadeInUp" data-wow-delay="800ms"> <img class="img-responsive IRFimg" alt="Zapp Orders" src="./assets/images/landing-img20/A4.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Zapp Orders </h3>
		  </div>
		  <div class="col-md-6 col-sm-6 col-lg-2 text-center wow fadeInUp" data-wow-delay="800ms"> <img class="img-responsive IRFimg" alt="Super Star Portfolio" src="./assets/images/landing-img20/A5.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Super Star Portfolio </h3>
		  </div>
		  <div class="col-md-6 col-sm-6 col-lg-2 text-center wow fadeInUp" data-wow-delay="800ms"> <img class="img-responsive IRFimg" alt="Charting signals" src="./assets/images/landing-img20/A6.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Charting signals to create trading strategies </h3>
		  </div>
			<p class="texttc wow fadeInUp" data-wow-delay="1000ms"><br/>*Terms and conditions apply. Investment in securities market are subject to market risks. Read all the related documents carefully before investing.
			Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors. Mutual Funds Investments are subject to market risk. Please read the offer and scheme related documents carefully before investing. The securities quoted are exemplary and not recommendatory or actual. Quantities, amounts, figures, graphs, and rates shown/displayed are exemplary and not recommendatory ar actual. </p>
		</div>
	  </div>
	</section>
	
	<!-- End New Invest Right app --> 
	
  </main>
  <!-- End #main --> 
  
  <!-- ======= Footer ======= -->
  <footer id="footer">
	<div class="container d-md-flex py-5 wow fadeInUp" data-wow-delay="300ms">
	  <div class="mr-md-auto text-center text-md-left">
		<div class="copyright"> <span>HDFC securities Ltd.</span>
		  <div class="credits">
			<p>Investment in securities market are subject to market risks. Read all the related documents carefully before investing.
			  Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to
			  investors. Mutual Funds Investments are subject to market risk. Please read the offer and scheme related documents carefully before investing. NPS is not a Exchange traded product and all
			  disputes related to the distribution activity of NPS will not have access to Exchange investor redressal forum or Arbitration mechanism. <br/>
			  <br/>
			  SEBI Registration No.: INZ000186937 (NSE, BSE,MSEI, MCX) |NSE Trading Member Code: 11094 | BSE Clearing Number: 393 | MSEI Trading Member Code: 30000 | MCX Member Code: 56015
			  | IN-DP-372-2018 (CDSL, NSDL) | CDSL DP ID: 12086700 | NSDL DP ID: IN304279 | AMFI Reg No. ARN -13549 | PFRDA Reg. No - POP 11092018 | IRDA Corporate Agent Licence No.CA0062
			  | Research Analyst Reg. No. INH000002475 | Investment Adviser: INA000011538 | CIN-U67120MH2000PLC152193 Registered Address: I Think Techno Campus, Building, B, Alpha, Office Floor
			  8, Near Kanjurmarg Station, Kanjurmarg (East), Mumbai -400 042. Tel -022 30753400. Compliance Officer: Mr. Murli V Karkera. Ph: 022-3045 3600, Email: complianceofficer@hdfcsec.com. <br/>
			  <br/>
			  Disclaimer: HDFC Securities Ltd. is a financial services intermediary and is engaged as a distributor of financial products &amp; services like Corporate FDs &amp; Bonds, Insurance, MF, NPS,Real Estate
			  services, Loans, NCDs, IPOs, E-Will &amp; E-Tax in strategic distribution partnerships. Customers need to check products &amp; features before investing since the contours of the product rates may
			  change from time to time. HDFC securities Ltd. is not liable for any loss or damage of any kind arising out of investments in these products. Investments in Equity, Currency, Futures &amp; Options are
			  subject to market risk. Clients should read the Risk Disclosure Document issued by SEBI &amp; relevant exchanges &amp; the T&amp;C on www.hdfcsec.com before investing. Global Investing, Digigold,
			  Insurance, Mutual Funds and NPS are not an approved product of the Exchanges and any dispute related to this will not be dealt at Exchange platform. MTF is subject to the provisions of SEBI
			  Circular CIR/MRD/DP/54/2017 dated June 13, 2017 and the terms and conditions mentioned in rights and obligations statement issued by HDFC Securities Ltd. <br/>
			  <br/>
			  Please note by submitting these details<br/>
			  1. You are authorising us to call you even though you may be registered under DNC. We shall Call/SMS you for a period of 12 months.<br/>
			  2. You are opting in to receive Whatsapp communication from us on the above registered mobile number.<br/>
			</p>
		  </div>
		</div>
	  </div>
	</div>
  </footer>
  <a id="back-to-top" href="#" class="btn btn-light btn-lg back-to-top top" role="button">&#8679;</a> 
  <!-- End Footer --> 
 